import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import Profile from '@/features/accounts/user-profile/profile';
import { Translation } from '@/hoslog-intl';
import { UserIcon } from '@/icons';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/account/profile/')({
  loader: () => {
    return {
      crumb: <CrumbTitle id="account.profile.page.title" icon={UserIcon} />,
      title: <Translation id="account.profile.page.title" />,
    };
  },
  component: RouteComponent,
});
function RouteComponent() {
  return <Profile />;
}
